module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('em', [_vm._v("Also by Jack Womack")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("AMBIENT"), _c('br'), _vm._v("TERRAPLANE"), _c('br'), _vm._v("HEATHERN"), _c('br'), _vm._v("ELVISSEY"), _c('br'), _vm._v("LET’S PUT THE FUTURE BEHIND US"), _c('br'), _vm._v("GOING, GOING, GONE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1435d98e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 60
// module chunks = 0